import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { grantsPassConfig } from "./data";

export default function GrantsPassPage() {
  return <OregonCityPageTemplate config={grantsPassConfig} />;
}